import { SvgLogo, SvgLogoProps } from './SvgLogo';

export const SendGrid = ({ height, width, ...props }: SvgLogoProps) => (
  <SvgLogo
    data-test="SendGrid"
    height={height}
    width={width}
    title="SendGrid Logo"
    titleId="sengrid-logo-title"
    viewBox="0 0 127.3 127.3"
    {...props}
  >
    <g>
      <rect x="42.4" y="84.9" fill="#99E1F4" width="42.4" height="42.4" />
      <polygon fill="#99E1F4" points="0,42.5 0,42.5 0,42.5 42.4,42.5 42.4,84.9 0,84.9" />
      <rect x="0" y="84.9" fill="#1A82E2" width="42.4" height="42.4" />
      <polygon
        fill="#00B2E3"
        points="127.3,42.5 127.3,42.5 84.9,42.5 84.9,84.9 127.3,84.9 127.3,42.5 	"
      />
      <rect x="42.4" y="0" fill="#00B2E3" width="42.4" height="42.4" />
      <polygon fill="#009DD9" points="42.4,42.5 42.4,84.9 84.9,84.9 84.9,42.5 84.9,42.5 	" />
      <rect x="84.9" y="0" fill="#1A82E2" width="42.4" height="42.4" />
    </g>
  </SvgLogo>
);
